export const getSendForgotPasswordEmail = ({ auth }) => auth.sendForgotPasswordEmail;
export const getLogin = ({ auth }) => auth.login;
export const getAuth = ({ auth }) => auth;
export const getChangePassword = ({ auth }) => auth.changePassword;
export const getUserNeedsToConfirmProfileInformation = ({ auth }) => auth.confirmationOfProfileInformation;
